import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import './InstagramFeed.css';

/* ====== Profiel ====== */
const profile = {
  username: 'onlinegrowthclub.nl',
  displayName: 'OnlineGrowthClub',
  followers: 279,
  avatar: '/images/ig/avatar.png', // zet in public/images/ig/
  bio: 'Wij bouwen websites en laten bedrijven online groeien. Lease je website met lage opstartkosten.',
  link: 'https://www.instagram.com/onlinegrowthclub.nl/',
};

/* ====== 6 posts ====== */
const posts = [
  { img: '/images/ig/1.png', href: 'https://www.instagram.com/p/DNFoPelKl2I/' },
  { img: '/images/ig/2.png', href: 'https://www.instagram.com/p/DNFp04OKzDH/' },
  { img: '/images/ig/3.png', href: 'https://www.instagram.com/p/DNFqBZJqV-u/' },
  { img: '/images/ig/4.png', href: 'https://www.instagram.com/p/DNFq7fwKdoD/' },
  { img: '/images/ig/5.png', href: 'https://www.instagram.com/p/DNFrZAPKrKB/' },
  { img: '/images/ig/6.png', href: 'https://www.instagram.com/p/DNFrrTpqtz3/' },
];

export default function InstagramFeed() {
  const followersText =
    new Intl.NumberFormat('nl-NL').format(profile.followers) + ' volgers';

  return (
    <section className="insta-section py-5 py-md-6">
      <h2 className="insta-heading">Volg ons op&nbsp;Instagram</h2>

      {/* Profielheader */}
      <div className="insta-profile">
        <img className="insta-avatar" src={profile.avatar} alt={`${profile.username} avatar`} />
        <div className="insta-meta">
          <div className="insta-row">
            <a className="insta-username" href={profile.link} target="_blank" rel="noopener">
              {profile.username}
            </a>
            <a className="insta-view-btn" href={profile.link} target="_blank" rel="noopener">
              Profiel bekijken
            </a>
          </div>
          <div className="insta-stats">
            <span className="insta-stat">{followersText}</span>
          </div>
          <div className="insta-bio">
            <strong>{profile.displayName}</strong>
            <p>{profile.bio}</p>
            <a className="insta-link" href={profile.link} target="_blank" rel="noopener">
              {profile.link}
            </a>
          </div>
        </div>
      </div>

      {/* Grid met posts */}
      <div className="insta-grid">
        {posts.map((p, i) => (
          <a
            key={i}
            className="insta-card"
            href={p.href}
            target="_blank"
            rel="noopener"
            aria-label={`Open post ${i + 1}`}
          >
            <img src={p.img} alt={`Instagram post ${i + 1}`} loading="lazy" />
            <span className="insta-overlay" aria-hidden="true" />
            <span className="insta-ico" aria-hidden="true">
              <FontAwesomeIcon icon={faInstagram} />
            </span>
          </a>
        ))}
      </div>

      {/* CTA */}
      <p className="insta-cta">
        <a className="insta-btn" href={profile.link} target="_blank" rel="noopener">
          Bekijk meer op Instagram
        </a>
      </p>
    </section>
  );
}
